module.exports = __webpack_public_path__ + "static/media/watch_parties.31327e88.webp";